import saving from '../../saving';
import actionTypes from '../constants/action-types';

const pageHtml = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE_HTML: {
      if (state.id !== action.payload.pageId) return state;

      return {
        ...state,
        html: action.payload.html,
      };
    }

    case saving.actionTypes.SET_STATUS: {
      if (action.payload.status === 'SAVED') {
        if (!state.html) return state;

        return {
          ...state,
          htmlCheckpoint: state.html,
        };
      }

      return state;
    }

    case actionTypes.SET_HTML_CHECKPOINT: {
      if (state.id !== action.payload.pageId) return state;

      return {
        ...state,
        htmlCheckpoint: action.payload.htmlCheckpoint,
      };
    }

    default:
      return state;
  }
};

export default pageHtml;
